import React, { useState } from "react";
import { HeroTextOnly } from '../../components';

import { Loader } from '../../components';
const AdvisorsContainer = () => {
  const heroImg = require('../../assets/header-experience.jpg');
  const arrayLoad = [
    heroImg
  ]
  return(
    <React.Fragment>
      <section className="company">
          <HeroTextOnly 
            title="Advisors" 
            paragraph="See how Invrsion has laid the foundation for a new era of technology and business."
            textBelow={false} 
            align="right"
            greyParagraph={false}
          />
          

            <div className="side--quote-wrap" >
              <div className="side--title side--title-adv">
                <img className="avatar-img" src={require('../../assets/advisors/pierlugi-bernasconi.jpeg')} /> 
                <h6 className="md--title">Pierluigi<br/>Bernasconi</h6>
              </div>
              <p className="preset-9 side--text">
              Multi awarded C-Level manager in the European retail field. CEO and shareholder of Mediaworld (Media Markt) in Italy (2,5 billion euro, 115 large stores, integrated ecommerce channel). Board member of Federdistribuzione and representative at Eurocommerce.                <a href="https://www.linkedin.com/in/pierluigi-bernasconi-b7172217b/" target="_blank" class="apply-wrap">
                  <p class="preset-10">Linkedin profile</p>
                  <img src="/arrow-up-right.svg" />
                </a>
              </p>
            </div>

            <div className="side--quote-wrap" >
              <div className="side--title side--title-adv">
                <img className="avatar-img" src={require('../../assets/advisors/mainardo-denardis.jpeg')} /> 
                <h6 className="md--title">Mainardo<br/>De Nardis</h6>
              </div>
              <p className="preset-9 side--text">
              Entrepreneur and former CEO of OMD, investor and advisor in over 10 initiatives. Board Director in several companies: marketing services, wine & spirits, health services, deep tech. 30 years in marketing services in Milano, London, New York ad manager and CEO for Omnicom, WPP and Dentsu Aegis. Great experience with international brands like Nissan, PepsiCo, Barilla, Luxottica.              
              <a href="https://www.linkedin.com/in/mainardod/" target="_blank" class="apply-wrap">
                  <p class="preset-10">Linkedin profile</p>
                  <img src="/arrow-up-right.svg" />
                </a>
              </p>
            </div>

            <div className="side--quote-wrap" >
              <div className="side--title side--title-adv">
                <img className="avatar-img" src={require('../../assets/advisors/andrea-giustina.jpeg')} /> 
                <h6 className="md--title">Andrea<br/>Giustina</h6>
              </div>
              <p className="preset-9 side--text">
              Business Angel Investor and Innovation Leader. He worked as Senior Manager at Nokia and as Head of Product Management, Systems Engineering and Technical Sales at Cisco. Many years of experience in the Technology & Innovation field as strategy advisor.
              <a href="https://www.linkedin.com/in/andrea-giustina-1589531/" target="_blank" class="apply-wrap">
                  <p class="preset-10">Linkedin profile</p>
                  <img src="/arrow-up-right.svg" />
                </a>
              </p>
            </div>

            <div className="side--quote-wrap" >
              <div className="side--title side--title-adv">
                <img className="avatar-img" src={require('../../assets/advisors/carlo-guareschi.jpeg')} /> 
                <h6 className="md--title">Carlo<br/>Guareschi</h6>
              </div>
              <p className="preset-9 side--text">
              Master Degree in Physics from the University of Pavia and an MBA from SDA Bocconi in Milan. Global career in the High-Tech industry, mainly in semiconductors.
              <a href="https://www.linkedin.com/in/carlo-guareschi/" target="_blank" class="apply-wrap">
                  <p class="preset-10">Linkedin profile</p>
                  <img src="/arrow-up-right.svg" />
                </a>
              </p>
            </div>
            <div className="side--quote-wrap" >
              <div className="side--title side--title-adv">
                <img className="avatar-img" src={require('../../assets/advisors/dante-malagrino.jpeg')} /> 
                <h6 className="md--title">Dante<br/>Malagrinò</h6>
              </div>
              <p className="preset-9 side--text">
              High-tech Executive and Start-Up Advisor.Master Degree in Information and Data Science from UC Berkeley. Accomplished entrepreneur and general manager with a strong technical background, a passion for innovation, and operational experience in both startups and large company environments. Over 10 years at Cisco as Director of Marketing and Vice President Engineering.                <a href="https://www.linkedin.com/in/dantemalagrino/" target="_blank" class="apply-wrap">
                  <p class="preset-10">Linkedin profile</p>
                  <img src="/arrow-up-right.svg" />
                </a>
              </p>
            </div>
            <div className="side--quote-wrap" >
              <div className="side--title side--title-adv">
                <img className="avatar-img" src={require('../../assets/advisors/eugenio-perrier.jpeg')} /> 
                <h6 className="md--title">Eugenio<br/>Perrier</h6>
              </div>
              <p className="preset-9 side--text">
              International brand and marketing executive, delivering consistent business results and brand health for world-class consumer food companies. After being Marketing & Brand Development & Innovation Director Americas for Barilla, Eugenio Perrier worked as Global Chief Marketing Officer for Sabra, and then as an advisor for many innovative startups.
                <a href="https://www.linkedin.com/in/eugenio-perrier/" target="_blank" class="apply-wrap">
                  <p class="preset-10">Linkedin profile</p>
                  <img src="/arrow-up-right.svg" />
                </a>
              </p>
            </div>
            <div className="side--quote-wrap" >
              <div className="side--title side--title-adv">
                <img className="avatar-img" src={require('../../assets/advisors/lorenzo-thione.jpeg')} /> 
                <h6 className="md--title">Lorenzo<br/>Thione</h6>
              </div>
              <p className="preset-9 side--text">
              Creator of Bing and successful entrepreneur in the US, Lorenzo Thione is co-founder and CEO of the tech startup, “The Social Edge”. Beyond his entrepreneurial activity and his engagement in the battles for the LGBT cause, today he is also a producer of musicals in Broadway, awarded by Tony Awards.
                <a href="https://www.linkedin.com/in/lorenzothione/" target="_blank" class="apply-wrap">
                  <p class="preset-10">Linkedin profile</p>
                  <img src="/arrow-up-right.svg" />
                </a>
              </p>
            </div>
          
          <div className="side--quote-wrap" >
            <div className="side--title side--title-adv">
              <img className="avatar-img" src={require('../../assets/advisors/alex-tosolini.jpeg')} /> 
              <h6 className="md--title">Alex<br/>Tosolini</h6>
            </div>
            <p className="preset-9 side--text">
            Senior Vice President of New Business Development at The Kroger Co. Board Member of Kroger Personal Finance, Kroger Foundation, 84.51° and Health Strategy Committee at Cincinnati University. Senior Vice President, Global e-Business and Vice President of Global eCommerce at Procter & Gamble.
              <a href="https://www.linkedin.com/in/alex-tosolini-50a07b1/" target="_blank" class="apply-wrap">
                <p class="preset-10">Linkedin profile</p>
                <img src="/arrow-up-right.svg" />
              </a>
            </p>
          </div>
          
      </section>
      <Loader arrayLoad={arrayLoad}/>
    </React.Fragment>
  )
}

export default AdvisorsContainer;